/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import assembler from 'url-assembler';

let config = require('../config/' + process.env.NODE_ENV);

class StaticRequest {
  static buildPeopleUrl(sponsor, isParticipant = false, offset, limit) {
    let path = assembler()
      .template(config.mtfs.path.people)
      .param('sponsor', sponsor)
      .param('isParticipant', isParticipant)
      .param('offset', offset)
      .param('limit', limit)
      .toString();
    return path;
  }

  static buildAllActiveStudiesUrl(userId, sponsor) {
    let path = assembler()
      .template(config.mtfs.path.studies)
      .param('userId', userId)
      .param('sponsor', sponsor)
      .toString();
    return path;
  }

  static buildParticipantsByStudyUrl(studyGid, nextPage, pageSize) {
    let path = assembler()
      .template(config.mtfs.path.participants)
      .param('studyGid', studyGid)
      .param('pageNumber', nextPage)
      .param('pageSize', pageSize)
      .toString();
    return path;
  }

  static buildNotesByStudyGidAndParticipantId(studyGid, participantId) {
    let path = assembler()
      .template(config.mtfs.path.notes)
      .param('studyGid', studyGid)
      .param('participantId', participantId)
      .toString();
    return path;
  }

  static buildGetResponsesDataUrl(participantId) {
    let path = assembler().template(config.mtfs.path.qamanagementData).param('participantId', participantId).toString();
    return path;
  }

  static buildGetConsentingOptInStateUrl(consentingGid) {
    let path = assembler()
      .template(config.mtfs.path.optInOptOutConsentingState)
      .param('consentingGid', consentingGid)
      .toString();
    return path;
  }

  static buildUpdateBiosampleCodeUrl(documentGid, documentVersion, questionId) {
    let path = assembler()
      .template(config.mtfs.path.qamanagementUpdateItemIdUrl)
      .param('documentGid', documentGid)
      .param('documentVersion', encodeURIComponent(documentVersion))
      .param('questionId', questionId)
      .toString();
    return path;
  }

  static buildChangeDocumentVersionUrl(participantId, documentGid, documentVersion) {
    let path = assembler()
      .template(config.mtfs.path.qamanagementDataDocumentVersion)
      .param('participantId', participantId)
      .param('documentGid', documentGid)
      .param('documentVersion', encodeURIComponent(documentVersion))
      .toString();
    return path;
  }

  static buildConsentDocumentsUrl(studyGid, participantId) {
    let path = assembler()
      .template(config.mtfs.path.documents)
      .param('studyGid', studyGid)
      .param('participantId', participantId)
      .toString();
    return path;
  }

  static buildSubjectPhiInformationUrl(studyGid, participantId) {
    let path = assembler()
      .template(config.mtfs.path.subjectPhi)
      .param('studyGid', studyGid)
      .param('participantId', participantId)
      .toString();
    return path;
  }

  static buildParticipantDocumentUrl(consentGid) {
    let path = assembler().template(config.mtfs.path.consentDocument).param('consentGid', consentGid).toString();
    return path;
  }

  static buildStudyInformationUrl(studyGid) {
    let path = assembler().template(config.mtfs.path.study).param('studyGid', studyGid).toString();
    return path;
  }

  static buildSiteInformationUrl(studyGid, participantId) {
    let path = assembler()
      .template(config.mtfs.path.sites)
      .param('studyGid', studyGid)
      .param('participantId', participantId)
      .toString();
    return path;
  }

  static buildAddNoteUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.addNote).param('consentingGid', consentingGid).toString();
    return path;
  }

  static builddocumentPendingPdfUrl(consentId, consentingId) {
    let path = assembler()
      .template(config.mtfs.path.documentPendingPdf)
      .param('consentId', consentId)
      .param('consentingId', consentingId)
      .toString();
    return path;
  }

  static buildDocumentSignedPdfUrl(consentingId) {
    let path = assembler().template(config.mtfs.path.documentSignedPdf).param('consentingId', consentingId).toString();
    return path;
  }

  static buildAddendumPdfUrl(addendumId) {
    let path = assembler().template(config.mtfs.path.addendumPdf).param('addendumId', addendumId).toString();
    return path;
  }

  static buildDeleteAddendumUrl(addendumId) {
    let path = assembler()
      .template(config.mtfs.path.deleteSignedOnPaperAddendumPdf)
      .param('addendumId', addendumId)
      .toString();
    return path;
  }

  static buildDocumentUnassignedPdfUrl(consentGid) {
    let path = assembler().template(config.mtfs.path.documentUnassignedPdf).param('consentGid', consentGid).toString();
    return path;
  }

  static buildGetRolesUrl(sponsor) {
    let path = assembler().template(config.mtfs.path.roles).query({ sponsor: sponsor }).toString();
    return path;
  }

  static buildUserAssignmentsUrl(userId, sponsor) {
    let path = assembler()
      .template(config.mtfs.path.userAssignments)
      .param('userId', userId)
      .query({ sponsor: sponsor })
      .toString();
    return path;
  }

  static buildAddAssignmentUrl(userId) {
    let path = assembler().template(config.mtfs.path.userAssignments).param('userId', userId).toString();
    return path;
  }

  static buildUpdateAssignmentUrl(assignmentId) {
    let path = assembler().template(config.mtfs.path.assignments).param('assignmentId', assignmentId).toString();
    return path;
  }

  static buildDeleteAssignmentUrl(assignmentId, sponsor) {
    let path = assembler()
      .template(config.mtfs.path.assignments)
      .param('assignmentId', assignmentId)
      .query({
        sponsor: sponsor
      })
      .toString();
    return path;
  }

  static buildHelpdeskAllPhoneNoUrl() {
    let path = assembler().template(config.mtfs.path.helpdeskNumbersAll).toString();
    return path;
  }

  static buildGetDocumentStatusesUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.documentStatuses).param('consentingGid', consentingGid).toString();
    return path;
  }

  static buildHelpdeskPhoneNoUrl(country) {
    let path = assembler().template(config.mtfs.path.helpdeskNumbers).param('country', country).toString();
    return path;
  }

  static buildSaveDocumentStatus(consentingGid, status, isProtected = true) {
    let path = assembler()
      .template(config.mtfs.path.saveDocumentStatus)
      .param('consentingGid', consentingGid)
      .param('status', status)
      .query({ protected: isProtected })
      .toString();
    return path;
  }

  static buildMonitorsUrl(sponsor, offset, limit) {
    let path = assembler()
      .template(config.mtfs.path.getMonitors)
      .param('sponsor', sponsor)
      .param('offset', offset)
      .param('limit', limit)
      .toString();
    return path;
  }

  static buildConsentingJournalUrl(consentingGid) {
    let path = assembler()
      .template(config.mtfs.path.consentingJournal)
      .param('consentingGid', consentingGid)
      .param('limit', '10000')
      .toString();
    return path;
  }

  static buildConsentingJournalPDFUrl(consentingGid) {
    let path = assembler()
      .template(config.mtfs.path.consentingJournalPDF)
      .param('consentingGid', consentingGid)
      .param('limit', '10000')
      .toString();
    return path;
  }

  static buildSaveParticipantStatusUrl() {
    let path = assembler().template(config.mtfs.path.saveParticipantStatus).toString();
    return path;
  }

  static buildGetFinalParticipantStatusesUrl() {
    let path = assembler().template(config.mtfs.path.getFinalParticipantStatuses).toString();
    return path;
  }

  static buildResetParticipantStatusUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.resetParticipantStatus)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static buildNotesPdfByStudyGidAndParticipantId(studyGid, participantId) {
    let path = assembler()
      .template(config.mtfs.path.notesPDF)
      .param('studyGid', studyGid)
      .param('participantId', participantId)
      .toString();
    return path;
  }

  static buildGetParticipantStatusesUrl() {
    let path = assembler().template(config.mtfs.path.getParticipantStatuses).toString();
    return path;
  }

  static buildOverallParticipantStatusUrl(studyGid, sites = []) {
    let path = assembler().template(config.mtfs.path.getOverallParticipantStatus).param('studyGid', studyGid);
    // TODO: confirm this is a good approach (multiple params with same name)
    for (let i = 0; i < sites.length; i++) {
      if (i === 0) path = path.param('siteGid', sites[i]);
      else path += `&siteGid=${sites[i]}`;
    }

    return path.toString();
  }

  static buildOrganizationsByStudyUrl(studyGid) {
    let path = assembler().template(config.mtfs.path.organizationsByStudy).param('studyGid', studyGid).toString();
    return path;
  }

  static buildParticipantJourneyUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.participantJourney)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static buildOrganizationsBySponsorUrl(sponsor) {
    let path = assembler().template(config.mtfs.path.organizationsBySponsor).param('sponsor', sponsor).toString();
    return path;
  }

  static buildParticipantJournalUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.participantJournal)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static buildparticipantJournalPDFUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.participantJournalPDF)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static buildOptInQuestionsReportUrl(protocolNumber) {
    let path = assembler()
      .template(config.mtfs.path.optInQuestionsReport)
      .query({
        protocolNumber: protocolNumber
      })
      .toString();
    return path;
  }

  static buildOptInQuestionsReportUrlAll(protocolNumber) {
    let path = assembler()
      .template(config.mtfs.path.optInQuestionsReportAll)
      .query({
        protocolNumber: protocolNumber
      })
      .toString();
    return path;
  }

  static buildAccessRightsChangesReportUrl(studyGid) {
    let path = assembler()
      .template(config.mtfs.path.accessRightsChangesReport)
      .param({
        studyGid: studyGid
      })
      .toString();
    return path;
  }

  static buildUploadSignedPdfUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.uploadSignedPdf).param('consentingGid', consentingGid).toString();
    return path;
  }

  static buildChangeAnswers(consentingGid) {
    let path = assembler().template(config.mtfs.path.changeAnswers).param('consentingGid', consentingGid).toString();
    return path;
  }

  static buildDeleteSignedPdfUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.deleteSignedPdf).param('consentingGid', consentingGid).toString();
    return path;
  }

  static fetchAvailableDocumentsUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.fetchAvailableDocuments)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static fetchConsentingUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.consenting).param('consentingGid', consentingGid).toString();
    return path;
  }

  static assignParticipantDocumentUrl(participantJourneyGid, consentId, operation) {
    let path = assembler()
      .template(config.mtfs.path.assignParticipantDocument)
      .param('participantJourneyGid', participantJourneyGid)
      .param('consentId', consentId)
      .param('operation', operation)
      .toString();
    return path;
  }

  static buildDelegationLogUrl(sponsorGid, studyGid) {
    let path = assembler()
      .template(config.mtfs.path.delegationLog)
      .param('study', studyGid)
      .param('sponsor', sponsorGid)
      .toString();
    return path;
  }

  static buildDelegationLogExportUrl(sponsorGid, studyGid) {
    let path = assembler()
      .template(config.mtfs.path.delegationLogExport)
      .param('study', studyGid)
      .param('sponsor', sponsorGid)
      .toString();
    return path;
  }

  static getUserByIdUrl(userId) {
    let path = assembler().template(config.mtfs.path.getUser).param('userId', userId).toString();
    return path;
  }

  static buildStartSLO() {
    let startSloUrl = [config.domain, config.mtfs.root, config.apiversion, config.mtfs.path.startSLO].join('');
    return assembler().template(startSloUrl);
  }

  static checkParticipantHasNewVersions(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.checkParticipantHasNewVersions)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static getTenantCookieUrl(tenantId) {
    let path = assembler().template(config.mtfs.path.tenantCookie).param('tenantId', tenantId).toString();
    return path;
  }

  static buildParticipantEmailUrl(participantJourneyGid) {
    let path = assembler()
      .template(config.mtfs.path.participantEmail)
      .param('participantJourneyGid', participantJourneyGid)
      .toString();
    return path;
  }

  static buildParticipantGenderUrl(participantId) {
    return assembler().template(config.mtfs.path.participantGender).param('participantId', participantId).toString();
  }

  static buildParticipantBirthdateUrl(participantId) {
    return assembler().template(config.mtfs.path.participantBirthdate).param('participantId', participantId).toString();
  }

  static buildParticipantAddressUrl(participantId) {
    return assembler().template(config.mtfs.path.participantAddress).param('participantId', participantId).toString();
  }

  static getReports(sponsorGid, userId) {
    let path = assembler()
      .template(config.mtfs.path.reports)
      .param('sponsorGid', sponsorGid)
      .param('userId', userId)
      .toString();
    return path;
  }

  static setQlikSession(userId, sponsorGid) {
    let path = assembler().template(config.mtfs.path.qlikSession).param('sponsorGid', sponsorGid).param('userId', userId).toString();
    return path;
  }

  static deleteQlikSession(userId) {
    let path = assembler().template(config.mtfs.path.deleteQlik).toString();
    return path;
  }

  static getReportsStatus(sponsorGid) {
    let path = assembler().template(config.mtfs.path.reportsStatus).param('sponsorGid', sponsorGid).toString();
    return path;
  }

  static countSignedConsentings() {
    let path = assembler().template(config.mtfs.path.countSignedConsentings).toString();
    return path;
  }

  static exportParticpantArchive() {
    let path = assembler().template(config.mtfs.path.exportArchive).toString();
    return path;
  }

  static cancelExportParticipantArchive() {
    let path = assembler().template(config.mtfs.path.batchCancelExport).toString();
    return path;
  }

  static downloadArchive(studyProtocolNumber, studyGid, username) {
    let path = assembler()
      .template(config.mtfs.path.batchDownload)
      .query({
        studyProtocolNumber: studyProtocolNumber,
        studyGid: studyGid,
        owner: username
      })
      .toString();
    return path;
  }

  static cancelDownloadArchive() {
    let path = assembler().template(config.mtfs.path.batchDownloadCancel).toString();
    return path;
  }

  static getBatchProgress(studyGid, username) {
    let path = assembler()
      .template(config.mtfs.path.batchProgress)
      .query({
        jobType: 'BATCH_ARCHIVING',
        studyGid: studyGid,
        owner: username
      })
      .toString();
    return path;
  }

  static getBatchArchivingStatus(studyGid, sites = []) {
    let path = assembler().template(config.mtfs.path.batchArchivingStatus).param({
      studyGid: studyGid
    });

    for (let i = 0; i < sites.length; i++) {
      if (i === 0) path = path.param('siteGid', sites[i]);
      else path += `&siteGid=${sites[i]}`;
    }

    return path.toString();
  }

  static buildConsentingMetadataUrl(consentingGid) {
    let path = assembler()
      .template(config.mtfs.path.consentingMetadata)
      .param('consentingGid', consentingGid)
      .toString();
    return path;
  }

  static buildSignedPdfUrl(consentingGid) {
    let path = assembler().template(config.mtfs.path.signedPdf).param('consentingGid', consentingGid).toString();
    return path;
  }

  static buildAcsEligibilityUrl() {
    let path = assembler().template(config.acsEligibility).toString();
    return path;
  }

  static buildAcsMigrateUrl() {
    let path = assembler().template(config.acsMigrate).toString();
    return path;
  }

  static buildRefreshTokensUrl() {
    let path = assembler().template(config.mtfs.path.refreshTokens).toString();
    return path;
  }
}
class Request {
  static instance() {
    return StaticRequest;
  }
}

export default Request;
